(function() {
  if (window.lbProductUpsellCaptureInit) return;
  window.lbProductUpsellCaptureInit = true;

  function getUpsellForForm(form) {
    if (!form) return null;
    return form.querySelector('[data-lb-upsell]') ||
      document.querySelector('[data-lb-upsell][data-form-id="' + form.id + '"]');
  }

  function buildUpsellItems(form) {
    const upsell = getUpsellForForm(form);
    if (!upsell) return [];

    const idInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const mainId = Number(idInput && idInput.value);
    const mainQty = Number(quantityInput && quantityInput.value || 1);
    const seen = new Set();
    const items = [];

    if (mainId && mainQty > 0) {
      items.push({ id: mainId, quantity: mainQty });
      seen.add(String(mainId));
    }

    upsell.querySelectorAll('.lb-product-upsell__checkbox:checked').forEach((input) => {
      const variantId = Number(input.dataset.variantId || input.value);
      const quantity = Number(input.dataset.quantity || 1);
      if (variantId && quantity > 0 && !seen.has(String(variantId))) {
        items.push({ id: variantId, quantity: quantity });
        seen.add(String(variantId));
      }
    });

    return items;
  }

  function setLoading(form, isLoading) {
    const productForm = form.closest('product-form') || form;
    const submitButton = productForm.querySelector('[type="submit"]');
    const spinner = productForm.querySelector('.loading-overlay__spinner');
    if (submitButton) {
      submitButton.toggleAttribute('aria-disabled', isLoading);
      submitButton.classList.toggle('loading', isLoading);
    }
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function showError(form, message) {
    const wrapper = form.closest('product-form') || form;
    const errorWrapper = wrapper.querySelector('.product-form__error-message-wrapper');
    const errorMessage = wrapper.querySelector('.product-form__error-message');
    if (errorWrapper) errorWrapper.toggleAttribute('hidden', !message);
    if (errorMessage && message) errorMessage.textContent = message;
  }

  function openCart() {
    const cartModal = document.querySelector('cart-popup');
    if (cartModal && typeof cartModal.open === 'function') {
      cartModal.open();
      return;
    }
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.open === 'function') {
      cartNotification.open();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
  }

  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;
    const items = buildUpsellItems(form);
    if (items.length <= 1) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    showError(form, false);
    setLoading(form, true);

    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then((response) => response.json().then((json) => ({ ok: response.ok, json: json })))
      .then((result) => {
        if (!result.ok || result.json.status) {
          showError(form, result.json.description || result.json.message || 'Impossible d’ajouter le produit au panier.');
          return;
        }
        document.dispatchEvent(new CustomEvent('lb:product-upsell-added', {
          bubbles: true,
          detail: { items: items, response: result.json }
        }));
        openCart();
      })
      .catch((error) => {
        console.error(error);
        showError(form, 'Impossible d’ajouter le produit au panier.');
      })
      .finally(() => setLoading(form, false));
  }, true);
})();

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartModal = document.querySelector('cart-popup');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      if (this.cartNotification) this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cartNotification && this.cartNotification.getSectionsToRender) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (this.cartModal) {
            this.cartModal.open();
          } else if (this.cartNotification) {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
